import React from 'react';
import useLanguageInitialization from '@/hooks/useLanguageInitialization';

/**
 * 语言初始化组件
 * 在应用启动时根据 useUserPermission 返回的语言值来设置语言
 */
const LanguageInitializer: React.FC = () => {
  const { currentLanguage, apiLanguage } = useLanguageInitialization();

  // 这个组件不需要渲染任何内容，只需要执行语言初始化逻辑
  return null;
};

export default LanguageInitializer;
